import React, { useMemo, useState } from "react";
import "../styles/Sidebar.css";

const Sidebar = ({
  filters,
  onFilterChange,
  onResetFilters,
  facilities,
  filteredCount,
  onOpenReportModal, // Add this prop
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // Get unique values for dropdowns
  const industries = useMemo(() => {
    const unique = [
      ...new Set(facilities.map((f) => f.industrySector).filter(Boolean)),
    ];
    return unique.sort();
  }, [facilities]);

  const counties = useMemo(() => {
    const unique = [
      ...new Set(facilities.map((f) => f.county).filter(Boolean)),
    ];
    return unique.sort();
  }, [facilities]);

  return (
    <>
      <button
        className="sidebar-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle filters"
      >
        {isOpen ? "✕" : "☰"}
      </button>

      {isOpen && (
        <div className="sidebar-overlay" onClick={() => setIsOpen(false)} />
      )}

      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h2>🔍 Filters</h2>
          <p className="results-count">
            Showing {filteredCount.toLocaleString()} of{" "}
            {facilities.length.toLocaleString()} TRI Reports
          </p>
        </div>

        <div className="filter-section">
          <label htmlFor="search">Search</label>
          <input
            id="search"
            type="text"
            placeholder="Search facilities, companies, cities..."
            value={filters.searchTerm}
            onChange={(e) => onFilterChange("searchTerm", e.target.value)}
            className="search-input"
          />
        </div>

        <div className="filter-section">
          <label htmlFor="carcinogen">Carcinogen Status</label>
          <select
            id="carcinogen"
            value={filters.carcinogen}
            onChange={(e) => onFilterChange("carcinogen", e.target.value)}
            className="filter-select"
          >
            <option value="all">All Reports</option>
            <option value="yes">Carcinogen Only</option>
            <option value="no">Non-Carcinogen Only</option>
          </select>
        </div>

        <div className="filter-section">
          <label htmlFor="industry">Industry Sector</label>
          <select
            id="industry"
            value={filters.industry}
            onChange={(e) => onFilterChange("industry", e.target.value)}
            className="filter-select"
          >
            <option value="all">All Industries</option>
            {industries.map((industry) => (
              <option key={industry} value={industry}>
                {industry}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-section">
          <label htmlFor="county">County</label>
          <select
            id="county"
            value={filters.county}
            onChange={(e) => onFilterChange("county", e.target.value)}
            className="filter-select"
          >
            <option value="all">All Counties</option>
            {counties.map((county) => (
              <option key={county} value={county}>
                {county}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-section">
          <button className="reset-button" onClick={onResetFilters}>
            Reset All Filters
          </button>
        </div>

        <div className="filter-section">
          <button
            className="download-report-button"
            onClick={onOpenReportModal}
          >
            📥 Download Report
          </button>
        </div>

        <div className="sidebar-footer">
          <p className="footer-text">
            💡 Click on markers for detailed information
          </p>

          <div className="data-source">
            <h4>About This Data</h4>
            <p>
              <strong>Source:</strong> EPA Toxic Release Inventory (TRI) 2024
            </p>
            <p className="source-description">
              The TRI tracks toxic chemical releases and waste management
              reported by industrial facilities.
            </p>
            <a
              href="https://www.epa.gov/toxics-release-inventory-tri-program/what-toxics-release-inventory"
              target="_blank"
              rel="noopener noreferrer"
              className="epa-link"
            >
              View EPA TRI Database →
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
